import { getIsNullish } from '../../jsUtils';

export const validateNegativeNumber = (
  value: string | number | undefined | null,
): string | boolean => {
  return getIsNullish(value) || Number(value) >= 0 || 'Can not be less than 0';
};
